export const environment = {
  production: true,
  buildId: '2794047485819001',
  configFile: 'config.json',
};
